export default "<footer class=\"ca-footer\"></footer>\n";